import { useImagings } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, FormInputField, Modal } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import { priceSchema } from '../../Laboratory/Modal'

type Props = {
  onClose: () => void
  price?: string
  id?: string
}

export const ImagingPrice = ({ onClose, price, id }: Props) => {
  const methods = useForm({ defaultValues: { price: price as string }, resolver: yupResolver(priceSchema) })
  const { updateImaging } = useImagings()
  const {
    handleSubmit,
    reset,
    formState: { isSubmitting }
  } = methods

  const onSubmit = async (data: any) => {
    const payload = {
      data: {
        attributes: {
          price: data.price
        },
        type: 'laboratories'
      }
    }

    try {
      await updateImaging({ data: payload, id: id as string })
      showToast('Pricing updated successfully')
      onClose()
    } catch (error) {
      getError(error)
    }
  }

  const handleClose = () => {
    onClose()
    reset()
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title="Edit Imaging Pricing">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }} width={'530px'}>
            <Box className="mx-auto w-full max-w-[399px]" flex={false} gap={'20px'}>
              <Box pad="0">
                <FormInputField label="Price" name="price" placeholder="" type="number" />
              </Box>
            </Box>
          </Box>
          <FormButton isLoading={isSubmitting} onClose={handleClose} submit="Update" />
        </Form>
      </Modal>
    </FormProvider>
  )
}
